"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function EuroBlue(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "euro-blue",
    size: "".concat(size),
    viewboxSize: "15"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: ".95"
  }, _react["default"].createElement("path", {
    d: "M-1-2h18v18H-1z"
  }), _react["default"].createElement("path", {
    fill: "#011875",
    fillRule: "nonzero",
    d: "M10.25 11.875A4.86 4.86 0 015.93 9.25h4.32l.75-1.5H5.435c-.037-.248-.06-.495-.06-.75s.022-.502.06-.75h4.815l.75-1.5H5.93a4.869 4.869 0 014.32-2.625c1.207 0 2.318.442 3.172 1.178l1.328-1.328A6.715 6.715 0 0010.25.25c-2.94 0-5.43 1.883-6.36 4.5H1.25L.5 6.25h3.045a6.203 6.203 0 000 1.5H1.25L.5 9.25h3.39c.93 2.617 3.42 4.5 6.36 4.5a6.701 6.701 0 004.5-1.725l-1.335-1.328a4.798 4.798 0 01-3.165 1.178z"
  }))));
}

EuroBlue.defaultProps = {
  size: 30
};
var _default = EuroBlue;
exports["default"] = _default;